const HERO_IFRAME_ID = 'hero-gallery-iframe';
const SHOW_IFRAME_CLASS = 'property-hero-gallery-iframe-show';
const PHOTO_GALLERY_BTN_ID = 'photo_gallery_btn';
const VIDEO_GALLERY_BTN_ID = 'video_gallery_btn';
const GALLERY_360_BTN_ID = '360_gallery_btn';
const JOIN_VIP_LIST_ID = 'join-vip-list';

export const propertyHeroSlider = () => {
  if (!document.querySelector('.hero-slider')) return;

  let heroIframeContainer;
  let totalSlides;

  const prev_btn = document.querySelector('.hero-prev-slide');
  const next_btn = document.querySelector('.hero-next-slide');
  const nav_by_tag = document.querySelectorAll('.word-carousel li');

  if (!next_btn || !prev_btn) return;

  let photo_gallery_btn;
  let video_gallery_btn;
  let gallery_360_btn;
  let joinVIPList;

  function setCurrentSlide(slideNum) {
    const currentSlide = document.querySelector('.word-counter .current-slide');
    currentSlide.textContent = `${slideNum}`;
  }

  function slidesAmount() {
    const ul = document.querySelector('.word-carousel ul');
    totalSlides = !ul ? 0 : ul.children.length;
    const wordCounter = document.querySelector('.word-counter .total-amount');
    if (wordCounter) {
      wordCounter.textContent = `${totalSlides}`;
    }
    if(totalSlides > 0){
      prev_btn.classList.add('disabled');
      next_btn.classList.remove('disabled');
    } else {
      prev_btn.classList.add('disabled');
      next_btn.classList.add('disabled');
    }
  }

  function navigateSlide(direction) {
    const currentSlide = document.querySelector('.property.hero-slide.active');
    const currentSlideIndex = parseInt(currentSlide.getAttribute('data-slide'));

    let nextSlideIndex;
    if (direction === 'next') {
      nextSlideIndex = currentSlideIndex + 1;
    } else if (direction === 'prev') {
      nextSlideIndex = currentSlideIndex - 1;
    }

    next_btn.classList.toggle('disabled', nextSlideIndex >= totalSlides);
    prev_btn.classList.toggle('disabled', nextSlideIndex <= 1);

    if (totalSlides < nextSlideIndex || nextSlideIndex < 1) return;

    const nextSlide = document.querySelector(
      `.hero-slide[data-slide="${nextSlideIndex}"]`
    );

    setCurrentSlide(nextSlideIndex);

    if (nextSlide) {
      currentSlide.classList.remove('active');

      nav_by_tag.forEach((item, index) => {
        if (index !== nextSlideIndex - 1) {
          item.classList.remove('active');
        } else {
          item.classList.add('active');
        }
      });

      moveSlide(nextSlideIndex);
      nextSlide.classList.add('active');
    }
  }

  function moveSlide(nextSlideIndex){
    let slideOffset = 0;
    window.setTimeout(() => {
      nav_by_tag.forEach((item, index) => {
        if(index < (nextSlideIndex - 1)) slideOffset += item.offsetWidth + 6;
      })

      nav_by_tag.forEach((item) => {
        item.style.transform = `translateX(${slideOffset * -1}px)`;
      })
    }, 200);
  }

  function navigateNextSlide() {
    navigateSlide('next');
  }

  function navigatePrevSlide() {
    navigateSlide('prev');
  }

  function navigateSlideByLi(li) {
    const slideIndex = parseInt(li.target.getAttribute('data-slide'));
    const slides = document.querySelectorAll('.property.hero-slide');
    const currentSlide = document.querySelector('.property.hero-slide.active');
    setCurrentSlide(slideIndex);

    if (slideIndex && slideIndex <= slides.length) {
      currentSlide.classList.remove('active');
      slides[slideIndex - 1].classList.add('active');
    }

    nav_by_tag.forEach((item, index) => {
      if (index !== slideIndex - 1) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      }
    });

    //moveSlide(slideIndex);
  }

  function onCloseModalMessageListener(e) {
    if (heroIframeContainer && e.data && e.data.includes && e.data.includes('gallery-modal')) {
      heroIframeContainer.classList.remove(SHOW_IFRAME_CLASS);
      const iframe = heroIframeContainer.querySelector('iframe');
      if (iframe) {
        iframe.remove();
      }
      document.body.style.overflow = 'auto';
      heroIframeContainer.innerHTML = '';
      window.removeEventListener('message', onCloseModalMessageListener);
    }
  }

  function createGalleryIframe(iframeSrc) {
    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    const divLoader = document.createElement('div');
    iframe.addEventListener('load', (e) => {
      divLoader.remove();
    })
    divLoader.classList.add('loader');
    divLoader.classList.add('active');
    divLoader.appendChild(document.createElement('span'));
    divLoader.appendChild(document.createElement('span'));
    divLoader.appendChild(document.createElement('span'));
    heroIframeContainer.appendChild(divLoader);
    heroIframeContainer.appendChild(iframe);
    heroIframeContainer.classList.add(SHOW_IFRAME_CLASS);
    document.body.style.overflow = 'hidden';
    window.addEventListener('message', onCloseModalMessageListener);
  }

  function onPhotoGalleryClick(e) {
    e.preventDefault();
    e.stopPropagation();
    let iframeSrc =
      photo_gallery_btn && photo_gallery_btn.getAttribute('data-iframe-url');
    if (heroIframeContainer && iframeSrc) {
      createGalleryIframe(iframeSrc);
    }
  }

  function onVideoGalleryClick(e) {
    e.preventDefault();
    e.stopPropagation();
    let iframeSrc =
      video_gallery_btn && video_gallery_btn.getAttribute('data-iframe-url');
    if (heroIframeContainer && iframeSrc) {
      createGalleryIframe(iframeSrc);
    }
  }

  function onGallery360Click(e) {
    e.preventDefault();
    e.stopPropagation();
    let iframeSrc =
      gallery_360_btn && gallery_360_btn.getAttribute('data-iframe-url');
    if (heroIframeContainer && iframeSrc) {
      createGalleryIframe(iframeSrc);
    }
  }

  function onJoinVipListClick() {
    const leaseUpForm = document.querySelector('section#lease-up-form');
    if (leaseUpForm) {
      if (leaseUpForm.classList.contains('show')) {
        leaseUpForm.classList.remove('show');
      } else {
        leaseUpForm.classList.add('show');
        let position = leaseUpForm.getBoundingClientRect();
        window.scrollTo({
          left: position.left,
          top: position.top + window.scrollY - 150,
          behavior: 'smooth',
        });
        document.dispatchEvent(new CustomEvent('leasUpFormOpened', {
          bubbles: true,
        }));
      }
    }
  }

  slidesAmount();
  photo_gallery_btn = document.getElementById(PHOTO_GALLERY_BTN_ID);
  video_gallery_btn = document.getElementById(VIDEO_GALLERY_BTN_ID);
  gallery_360_btn = document.getElementById(GALLERY_360_BTN_ID);
  joinVIPList = document.getElementById(JOIN_VIP_LIST_ID);
  heroIframeContainer = document.getElementById(HERO_IFRAME_ID);

  if (photo_gallery_btn) {
    photo_gallery_btn.addEventListener('click', onPhotoGalleryClick);
  }

  // if (video_gallery_btn) {
  //   video_gallery_btn.addEventListener('click', onVideoGalleryClick);
  // }

  if (gallery_360_btn) {
    gallery_360_btn.addEventListener('click', onGallery360Click);
  }

  if (joinVIPList) {
    joinVIPList.addEventListener('click', onJoinVipListClick);
  }

  next_btn.addEventListener('click', navigateNextSlide);
  prev_btn.addEventListener('click', navigatePrevSlide);

  nav_by_tag.forEach((item) => {
    item.addEventListener('click', navigateSlideByLi);
  });
};



// WEBPACK FOOTER //
// ./src/templates/components/property-hero-gallery/property-hero-gallery.js